(function () {
  "use strict";

  function frameNameForRadio(radio) {
    if (!radio || !radio.id) return "";
    var label = document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
    return label ? label.textContent.trim() : "";
  }

  function findFrameRadio(frame) {
    return Array.from(document.querySelectorAll('input[type="radio"][data-option-position="2"]'))
      .find(function (radio) {
        return frameNameForRadio(radio) === frame;
      });
  }

  function updateCards(frame) {
    document.querySelectorAll(".sc-frame-card").forEach(function (card) {
      var selected = card.dataset.frame === frame;
      card.classList.toggle("is-selected", selected);
      card.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    document.querySelectorAll("[data-sc-selected-frame]").forEach(function (label) {
      label.textContent = frame;
    });
  }

  document.addEventListener("click", function (event) {
    var card = event.target.closest && event.target.closest(".sc-frame-card");
    if (!card) return;

    event.preventDefault();
    var radio = findFrameRadio(card.dataset.frame);
    if (!radio) return;

    var label = radio.id && document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
    if (label) {
      label.click();
    } else {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateCards(card.dataset.frame);
  });

  document.addEventListener("change", function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('input[type="radio"][data-option-position="2"]')) return;
    updateCards(frameNameForRadio(radio));
  });
})();
